/**
 * Fix for mobile browsers where hiding/showing the bottom toolbar
 * causes a gap below position:fixed elements.
 *
 * Two mechanisms:
 * 1. On window resize (triggered when toolbar hides/shows), force the
 *    browser to recalculate fixed positioning by toggling position.
 * 2. Use visualViewport API to set --viewport-offset-bottom for cases
 *    like virtual keyboard where innerHeight and visualViewport diverge.
 */
(function () {
  var root = document.documentElement;
  var pending = false;
  var lastHeight = window.innerHeight;

  function update() {
    pending = false;
    var currentHeight = window.innerHeight;

    /* --- visualViewport offset (virtual keyboard, etc.) --- */
    if (window.visualViewport) {
      var vv = window.visualViewport;
      var offset = currentHeight - vv.height - vv.offsetTop;
      root.style.setProperty(
        '--viewport-offset-bottom',
        Math.max(0, Math.round(offset)) + 'px'
      );
    }

    /* --- toolbar hide/show: force fixed-position recalculation --- */
    if (currentHeight !== lastHeight) {
      lastHeight = currentHeight;
      var els = document.querySelectorAll('.sticky-atc, .bundle-sticky-bar');
      for (var i = 0; i < els.length; i++) {
        /* Synchronously toggle position so the browser must
           recompute the fixed layout against the new viewport.
           All changes happen before the next paint — no flash. */
        els[i].style.position = 'static';
        void els[i].offsetHeight;   // force synchronous reflow
        els[i].style.position = ''; // restore CSS value (fixed)
      }
    }
  }

  function schedule() {
    if (!pending) {
      pending = true;
      requestAnimationFrame(update);
    }
  }

  window.addEventListener('resize', schedule);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', schedule);
    window.visualViewport.addEventListener('scroll', schedule);
  }

  update();
})();
